import { useRef, useState } from 'react'

import shrinkIcon from '../../imgs/pc-actions/shrink-package-icon.svg'
import shrinkCompletedIcon from '../../imgs/pc-actions/shrink-package-icon-completed.svg'
import shrinkDisabledIcon from '../../imgs/pc-actions/shrink-package-icon-disabled.svg'
import Tooltip from '../Tooltip'
export const shrinkButtonTexts = {
  default: 'צמצום חבילה',
  disabled: 'צמצום חבילה',
  cancel: 'ביטול צמצום',
  completed: 'חבילה צומצמה',
  tooltipTitle: 'בקשה בטיפול',
  tooltipDescription: 'לא ניתן לשלוח בקשה לצמצום כרגע',
  autoShrinkTitle: 'החבילה כבר צומצמה',
  autoShrinkDescription: 'החבילה צומצמה ללא תשלום!',
}
export const ShrinkButton = ({ item, onShrinkRequest, onCancelShrinkRequest, texts = shrinkButtonTexts }) => {
  const [visibleTooltip, setVisibleTooltip] = useState(false)
  const shrinkIconRef = useRef(null)

  const createTooltipCloser = isOpen => {
    if (!isOpen) {
      setVisibleTooltip(false)
    }
  }

  // Return request active - disabled
  if (item.isPaid || item.isShipped || item.isReturnRequestActive) {
    return (
      <>
        <button className='tool-cont' onClick={() => setVisibleTooltip(true)}>
          <div className='tool-cont-img-bcg' ref={shrinkIconRef}>
            <img src={shrinkDisabledIcon} alt='Shrink package disabled' />
          </div>
          <span>{texts.disabled}</span>
        </button>
        <Tooltip
          title={texts.tooltipTitle}
          description={texts.tooltipDescription}
          isTooltipOpen={visibleTooltip}
          setIsTooltipOpen={createTooltipCloser}
          triggerRef={shrinkIconRef}
        />
      </>
    )
  }

  // Cancel shrink request
  if (item.isShrinkRequestActive) {
    return (
      <button className='tool-cont' onClick={onCancelShrinkRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={shrinkDisabledIcon} alt='Cancel shrink' />
        </div>
        <span style={{ color: 'red' }}>{texts.cancel}</span>
      </button>
    )
  }

  // Shrink request approved
  if (item.isShrinkRequestApproved) {
    return (
      <button className='tool-cont'>
        <div className='tool-cont-img-bcg'>
          <img src={shrinkCompletedIcon} alt='Shrink completed' />
        </div>
        <span>{texts.completed}</span>
      </button>
    )
  }
  const allowedWarehouses = ['USA', 'UK']
  const allowShrinkGr = item.warehouse === 'GR' && item.contents.some(c => c.productCategory === 'Shoes')

  if (!item.isShrinkRequestActive && !item.isShrinkRequestApproved && (allowedWarehouses.includes(item.warehouse) || allowShrinkGr)) {
    return (
      <button className='tool-cont' onClick={onShrinkRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={shrinkIcon} alt='Shrink package' />
        </div>
        <span>{texts.default}</span>
      </button>
    )
  }

  return (
    <>
      <button className='tool-cont' onClick={() => setVisibleTooltip(true)}>
        <div className='tool-cont-img-bcg'>
          <img src={shrinkDisabledIcon} alt='Shrink package auto' ref={shrinkIconRef} />
        </div>
        <span>{texts.disabled}</span>
      </button>
      <Tooltip
        title={texts.autoShrinkTitle}
        description={texts.autoShrinkDescription}
        isTooltipOpen={visibleTooltip}
        setIsTooltipOpen={createTooltipCloser}
        triggerRef={shrinkIconRef}
      />
    </>
  )
}
